import moment from 'moment';
import { any } from 'prop-types';
import React, { useEffect, useMemo } from 'react';

import { Text } from '@sitecore-jss/sitecore-jss-react';
import { DATE_FORMAT,useAppendBookingBlockDay } from '@utils/customsHook/useAppendBookingBlockDay';

import DatePickerEvent from '../../DatePickerEvent';
import useSelectStoreAndDateContext from '../useSelectStoreAndDateContext';
import { generateDateRange, MILLISECOND_PER_DAY } from '../utils';
import useSortExcludeDate from './useSortExcludeDate';

const SelectPreferDate = ({ layoutData }) => {
  const { formik, isDisableFormSection } = useSelectStoreAndDateContext();
  const appendBookingBlockDayService = useAppendBookingBlockDay();
  // const numberOfGuest = useMemo(() => {
  //   return [layoutData?.justMeButtonText || layoutData?.['Just Me Label'], layoutData?.mePlus1PlaceholderText || layoutData?.['Me And Others']];
  // }, [layoutData]);

  const dateRange = useMemo(() => {
    return generateDateRange(layoutData?.campaign?.Stores, formik.values.storeId);
  }, [layoutData?.campaign?.Stores, formik.values.storeId]);

  const blockDayBookingNumber = useMemo(() => {
    const parseBlockBookingDay = Number(layoutData?.['block_day_booking'] || 0);

    return Number.isInteger(parseBlockBookingDay) ? parseBlockBookingDay : 0;
  }, [layoutData]);

  const excludedDates = useSortExcludeDate(
    dateRange,
    layoutData?.campaign,
    formik.values.storeId,
    null,
    layoutData?.appointment?.Date
  );

  const appendExcludedDates = useMemo(
    () => appendBookingBlockDayService({
      excludedDates,
      blockDayBookingNumber,
      defaultDate: layoutData?.appointment?.Date
    }),
    [excludedDates, blockDayBookingNumber, layoutData?.appointment?.Date]
  );

  useEffect(() => {
    const firstDateRangeItem = dateRange?.[0];
    const startTime = firstDateRangeItem?.start?.getTime();
    const endTime = firstDateRangeItem?.end?.getTime();
    const totalDay = (endTime - startTime) / MILLISECOND_PER_DAY;
    let selectedDate = formik.values.date;

    for (let i = 0; i <= totalDay; i++) {
      if (selectedDate.getTime() >= startTime && selectedDate.getTime() <= endTime) {
        const checkExistInExcludedDate = appendExcludedDates.find((date) => moment(moment(selectedDate)
          .format(DATE_FORMAT)).isSame(moment(date).format(DATE_FORMAT)));

        if (checkExistInExcludedDate) {
          selectedDate.setDate(selectedDate.getDate() + 1);
        } else {
          formik.setFieldValue('date', selectedDate);
          break;
        }
      }
    }
  }, [appendExcludedDates.length, dateRange]);

  return (
    <div className='col-12 col-lg-4'>
      <div className='select-store__date'>
        <div className={isDisableFormSection ? 'be-schedule-appointment__disable-form' : ''}>
          <Text className='select-store__date__title' field={layoutData.selectDateLabel || layoutData?.['Select A Preferred Date Label']} tag='h4' />
          <DatePickerEvent
            excludeDates={appendExcludedDates}
            selected={formik.values.date}
            includeDateIntervals={dateRange}
            onChange={(date) => formik.setFieldValue('date', date)}
            availableText={layoutData?.availableTranslationText?.value}
            notAvailableText={layoutData?.notAvailableTranslationText?.value}
            selectedText={layoutData?.selectedTranslationText?.value}
          />
        </div>
        {/*<div className='select-store__date__option'>*/}
        {/*  <Text field={layoutData?.numberOfGuestsLabel || layoutData?.['Number Of Guest']} />*/}
        {/*  <div className='select-store__date__option__list'>*/}
        {/*    {numberOfGuest.map((option, index) => (*/}
        {/*      <div key={index} className='select-store__date__option__list__item'>*/}
        {/*        <div className='form-group'>*/}
        {/*          <input*/}
        {/*            id={option.value}*/}
        {/*            value={index + 1}*/}
        {/*            type={'radio'}*/}
        {/*            defaultChecked={formik.values.numberOfGuests === index + 1}*/}
        {/*            name='optionGuest'*/}
        {/*            onChange={(event) => formik.setFieldValue('numberOfGuests', +event.target.value)}*/}
        {/*          />*/}
        {/*          <Text field={option} tag='label' htmlFor={option.value} />*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    ))}*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    </div>
  );
};

SelectPreferDate.propTypes = {
  layoutData: any
};

export default SelectPreferDate;
